export default __webpack_public_path__ + "static/media/img_manage_service_banner.300aa0b4.png";